const content = {
  component: "PageTypeA",
  cssClass: "page-two",
  meta: {
    title: "زيت زيتون بنشأة مضمونة وجودة مضمونة",
    description: `تُحدث تكنولوجيا "البلوك تشين" تغيرًا جوهريًا في منظومة توريد منتجات زيت الزيتون، وتضمن للعملاء الثقة في أصالة المنتج ومصدر نشأته.`,
    og: {
      type: "website",
      title: `تكنولوجيا "البلوك تشين" تضمن أصالة المنتج - اقرأ المزيد`,
      description: `في عالم يشهد تناقصاً للثقة، أصبح من الضروري لموردي زيت الزيتون إثبات أصالة ونشأة منتجاتهم. ومن خلال استخدام تكنولوجيا "البلوك تشين"، أصبحت منظومة التوريد معلنة ومتاحة للجميع وقابلة للتبع، بما يضمن ثقة جميع الأطراف من مصدر المنتج ونشأته.`,
      image: require("../../assets/images/social/guaranteed-origins-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title: `اعرف كيف أحدثت تكنولوجيا "البلوك تشين" ثورة في منظومة توريد زيت الزيتون`,
      description: `ما بين 50 إلى 90% من منتجات زيت الزيتون يحمل علامة تجارية زائفة. ففي عالم تتآكل فيه ثقة المستهلكين، تضمن مزايا تكنولوجيا "البلوك تشين" - من حيث الشفافية والحماية وسهولة التوسيع - للموردين ضمان نشأة منتجاتهم.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/guaranteed-origins-300x300.jpg")
    }
  },
  title: "<span>زيت زيتون بنشأة مضمونة وجودة مضمونة</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/guaranteed-origins-pre.jpg"),
    loaded: require("../../assets/images/bgs/guaranteed-origins.jpg"),
    mobile: require("../../assets/images/bgs/guaranteed-origins-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  // floodlight: 'https://3573292.fls.doubleclick.net/activityi;src=3573292;type=oracl0;cat=fy19q0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;ord=1;',
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
          <h2>مذاق زيت الزيتون الأصيل</h2>
          <p>تصوّر نفسك مسترخيًا في أجواء إيطالية تحت أشعة الأصيل وأنت ترشف مشروبك المفضّل، وقد بُسطت أمامك، على طاولة خشبية ريفية، مائدةٌ عامرة بكل ما لذ وطاب من أطباق الخضرواتِ المطهوة في الفرن التي تعلوها جبنة البارميزان؛ مع خبز البانيني المشوي الهش، وشرائح الطماطم الطازجة باللونين الأحمر والبرتقالي الداكنين.  </p>
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>عندها قد تشعر بالحيرة فتتساءل: أيّ الأطباق تختار منها قضمتك الأولى، وإذ ببصرك يقع على صحن صغير يتلألأ بسائل ذهبي من بين أطباق المائدة العامرة، فتغمس فيه قطعة من الخبز المحمص وتأكل مستمتعًا بالمذاق الحرِّيف ونفحات الرائحة الزكية لزيت الزيتون البكر الممتاز الأصليّ. </p>
          <p>تلك هي التجربة التي ترغب شركة Certified Origins وعلامتها التجارية Bellucci أن يستمتع العملاء بها في مختلف أنحاء العالم. وهي تجربة تتجددَ في كل مرة يحل فيها زيت الزيتون الأصلي ضيفًا على موائد الطعام سواء مطهيًا أو كغموس لذيذ. يزداد اهتمام العملاء بمنشأ المنتج وأصالته، ولهذا يَعتبر نحو 60% من المستهلكين في المملكة المتحدة بلد المنشأ عنصرًا لا يقل أهمية عن فوائد المنتج أو ثمنه. (1)<sup>1</sup></p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/oil.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>إلا أن ثقة العملاء في الوقت الراهن أصبحت مُهدّدَة بسبب فئة قليلة من الشركات سيئة السمعة، وجرّاء القيود التي تكبل التشريعات التي تنظم عمل الأطراف الخارجية. وفقًا للتقارير والدراسات، تتراوح نسبة منتجات الزيت المغشوشة التي تدعي أنها "زيت زيتون بكر ممتاز" ما بين 50-90% من إجمالي زيوت الزيتون المباعة حول العالم.<sup>2</sup></p>
          <p>وهذه الحقيقة المؤسفة هي السبب وراء التزام شركة Certified Origins الصارم بضمان إثبات المصدر والتحقق من الجودة. تشرح الأمرَ سوزان تستا، مديرة قسم ابتكارات الطهي بقولها: "تكمن الفلسفة الجوهرية لعلامتنا التجارية Bellucci في اكتساب ثقة في جودة الزيت من خلال تعقُّب الأصل وإثبات المنشأ". وتضيف: "نتعاون عن قرب مع الآلاف من أُسر المزارعين الصغيرة التي تعتني بأشجار الزيتون على الطريقة الإيطالية التقليدية وتوفر أجود أصناف الزيتون لتصنيع زيت Bellucci  البكر الممتاز وتوليفات أخرى."</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `نتعاون عن كثب مع أُسر صغيرة لآلاف المزارعين الذين يعتنون بأشجار الزيتون على الطريقة الإيطالية التقليدية، ويوفرون أجود الأصناف لتصنيع زيت Bellucci البكر الممتاز وتوليفات أخرى.`,
        author: `Susan Testa`,
        position: `مديرة قسم ابتكارات الطهي, Certified Origins`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/GuaranteedOrigins_CertifiedOrigins_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <h3>تكنولوجيا "البلوك تشين" وترقية قابلية التتبع</h3>
          <p>لطالما كانت Certified Origins، ولا تزال، رائدة الابتكار في مجالها. لذا فلا عجب أن تكون من بين طليعة الشركات التي استخدمت تكنولوجيا "البلوك تشين" في تتبّع معاملات منظومة التوريد. وقد كان لتلك التكنولوجيا دور كبير في تعزيز ودعم برنامج الشركة الصارم ومتعدد المستويات في التنظيم واعتماد المصدر.</p>
          <p>تستخدم شركة Certified Origins تكنولوجيا "البلوك تشين" في تتبّع رحلة زيت الزيتون من التصنيع حتى التسليم؛ في عملية تُماثل السجلّ الإلكترونيّ الآمن، وهي عبارة عن "سلسلة" من "كتل" المعلومات. وتتميز هذه التكنولوجيا بأنها منيعة ضد التلاعب والتعديل، وتحتوي مسارًا دائمًا وعلنيًا من المعلومات.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/GuaranteedOrigins_InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <h3>كيف تدعم تكنولوجيا "البلوك تشين" الشفافية في إثبات نشأة الأغذية</h3>
          <p>لا يزال البعض يحصر تكنولوجيا "البلوك تشين" في العملات المشفرة. لكن نطاق استخدام هذه التكنولوجيا قد اتسع ليشمل ميادين أبعد من عملات البيتكوين والإيثيريوم. في الحقيقة، يعتقد الخبراء أن هذه التكنولوجيا مهيّئة لتكون ذات تأثير أوسع بكثير من الإنترنت على الممارسات التجارية للشركات.<sup>3</sup></p>
          <p>المعلومات التي يتم إدخالها في تكنولوجيا "البلوك تشين" لا تُقبل إلا باتفاق الآراء، وهي آمنة تمامًا وتسهل مراجعتها والتحقق منها. وبالنسبة لموردي الأغذية مثل شركة Certified Origins تحقق هذه التكنولوجيا قيمة تجارية مهمة ثلاثية الأوجُه:</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>تعزيز الشفافية: بإمكان شركة Certified Origins توثيق موطن ثمار الزيتون ومحطات انتقالها. كما توفر هذه السجلات أدلة إضافية للجهات التنظيمية وتصلح للوفاء بشروط التوثيق والاعتماد.</p>
          <p>أمان معزَّز: في وجود ملف مشترك غير قابل للتبديل أو التغيير تقل الحاجة أو تنتفي إلى مراجعات تدقيقية تستغرق وقتًا طويلًا أو تحتاج إلى عدد كبير من الموظفين.</p>
          <p>آفاق غير محدودة لتوسيع نطاق الأعمال: بإمكان كل عائلات وجمعيات المزارعين التي تتعاون مع شركة Certified Origins المشاركة بلا أي قيود على العدد أو تأثير على كفاءة الأداء.</p>
          <p>توفر تكنولوجيا "البلوك تشين" فرصة سانحة للابتكار والإبداع. فكلما ازدادت انتشارًا في مجالات التجارة والأعمال وفي مختلف ميادينَ الصناعات، سيظهر المزيدُ من التطبيقات وحالات الاستخدام المتخصصة، وسيتجلّى المزيد من فوائدها وأوجه أهميتها. شركة Certified Origins وعلامتها التجارية Bellucci تتبوأن مكانة مهيّئة لجني ثمار هذا التغيير التكنولوجي.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionReferences",
      content: {
        references: [
          {
            title: "nielson.com",
            source:
              "https://www.nielsen.com/uk/en/press-room/2016/nielsen-brand-origins.html"
          },
          {
            title: "ifcnr.org",
            source:
              "https://ifcnr.org/extra-virgin-olive-oil-fraud-yes-no-maybe/"
          },
          {
            title: "business.com",
            source:
              "https://www.business.com/articles/blockchain-technology-impact-future/"
          }
        ]
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `طوّر أعمالك مع حلول وتكنولوجيا Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: `تقرير "صُنّاع القرار والتكنولوجيا"`,
            url:
              "https://www.oracle.com/sa-ar/area-of-interest/it/leading-technologies-survey.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_IT_AW_HI_CM_SA_C33_Q33_RT",
            buttonCopy: "اقرأ التقرير"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
